export const getters = {
	isLoader: state => (state.loader)
}



// WEBPACK FOOTER //
// ./src/store/modules/Loader/getters.js